import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

// mui
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
// utils
import axios from "axios";
import UploadTool from "./uploadTool/UploadTool";
import Quota from "../../component/Quota";
import Act from "../../../../../../../store/actions";
import { StoreContext } from "../../../../../../../store/StoreProvider";

const TopPanel = () => {
  const [_, dispatch] = useContext(StoreContext);

  useEffect(() => {
    const apiStr = process.env.REACT_APP_OCR_QUOTA_API;
    (async () => {
      const data = await axios.post(apiStr);
      const curUsage = data?.data?.totalImagesProcessed;
      const quotaPercentage = Math.floor(((1000 - curUsage) / 1000) * 100);
      const isQuotaExceeded = quotaPercentage <= 0;

      dispatch({
        type: Act.SNA_SET_QUOTA,
        payload: isQuotaExceeded ? 0 : quotaPercentage,
      });

      if (isQuotaExceeded) {
        dispatch({
          type: Act.SNA_SET_OCR_QUOTA,
          payload: isQuotaExceeded,
        });
      }
    })();
  }, []);

  return (
    <Grid container justifyContent="space-between" alignItems="center" mb={2}>
      <Grid item>
        <Typography
          textAlign="left"
          variant="subtitle1"
          sx={{ fontWeight: 700, fontSize: "20px" }}
        >
          <FormattedMessage
            id="sna.sidetool.digitalAITool.ocr.title"
            defaultMessage="OCR 文字辨識"
          />
        </Typography>
        <Quota text="OCR" />
        <Typography
          textAlign="left"
          variant="body2"
          sx={{ color: "#6D6D6D", fontSize: "14px" }}
        />
      </Grid>
      <Grid item>
        <UploadTool />
      </Grid>
    </Grid>
  );
};

export default TopPanel;
